export const platformSlugs = ["nuvemshop", "shopify", "wix", "atlassian", "custom"] as const;
export type PlatformSlug = (typeof platformSlugs)[number];

export const seedStatuses = [
  "research",
  "candidate",
  "approved",
  "building",
  "staging",
  "homologation",
  "published",
  "scaling",
  "maintenance",
  "paused",
  "killed",
] as const;
export type SeedStatus = (typeof seedStatuses)[number];

export const eventFamilies = [
  "distribution",
  "listing",
  "installation",
  "activation",
  "onboarding",
  "first_value",
  "trial",
  "subscription",
  "payment",
  "core_available",
  "core_started",
  "core_succeeded",
  "core_failed",
  "core_blocked",
  "feature_used",
  "support",
  "review",
  "incident",
] as const;
export type EventFamily = (typeof eventFamilies)[number];

export type SeedEventEnvelope = {
  schemaVersion: 1;
  seedId: string;
  deploymentId: string;
  platform: PlatformSlug;
  tenantId: string;
  eventId: string;
  eventName: string;
  eventFamily: EventFamily;
  occurredAt: string;
  value?: number;
  metadata?: Record<string, string | number | boolean | null>;
};

export type EventBatch = { schemaVersion: 1; events: SeedEventEnvelope[] };

export type Platform = { id: string; slug: PlatformSlug; name: string };
export type Seed = {
  id: string;
  seedKey: string;
  name: string;
  summary: string | null;
  status: SeedStatus;
  createdAt: string;
};
export type Deployment = {
  id: string;
  seedId: string;
  platformId: string;
  platformSlug: PlatformSlug;
  name: string;
  externalAppId: string | null;
  status: string;
  isPrimary: boolean;
};
export type Installation = {
  id: string;
  deploymentId: string;
  tenantId: string;
  status: string;
  installedAt: string;
  activatedAt: string | null;
  onboardingCompletedAt: string | null;
  firstValueAt: string | null;
  trialStartedAt: string | null;
  paidStartedAt: string | null;
  uninstalledAt: string | null;
};
export type Subscription = {
  id: string;
  deploymentId: string;
  tenantId: string;
  status: string;
  planExternalId: string | null;
  mrrCents: number;
  currency: string;
  startedAt: string;
  trialStartedAt: string | null;
  trialEndsAt: string | null;
  canceledAt: string | null;
};
export type RevenueEntry = {
  id: string;
  deploymentId: string;
  tenantId: string | null;
  amountCents: number;
  currency: string;
  kind: string;
  recognizedAt: string;
};
export type SeedEventRow = SeedEventEnvelope & {
  id: string;
  source: "automatic" | "manual_import" | "manual_entry";
  ingestedAt: string;
};

export type DateRange = { from: Date; to: Date };
export type Granularity = "day" | "week" | "month";
export type AnalyticsFilter = {
  from: Date;
  to: Date;
  seedId?: string;
  deploymentId?: string;
  platformId?: string;
  granularity: Granularity;
};

export type PortfolioMetrics = {
  installs: number;
  activeInstallations: number;
  activations: number;
  activationRate: number | null;
  firstValues: number;
  firstValueRate: number | null;
  trialsStarted: number;
  paidCustomers: number;
  paidFromTrialRate: number | null;
  paidFromInstallRate: number | null;
  mrrCents: number;
  arrCents: number;
  revenueCents: number;
  arpuCents: number | null;
  churnedCustomers: number;
  logoChurnRate: number | null;
  medianTtfvMinutes: number | null;
  openIncidents?: number;
};
